<!-- NG-ZORRO -->
<nz-layout class="ant-layout-parent">
  <nz-layout>
    <nz-content>
      <router-outlet></router-outlet>
    </nz-content>
  </nz-layout>
</nz-layout>